/**
 * ChatScopeBadge — thin wrapper around WorkspaceScopeSelector for the chat panel header.
 * Keeps the existing prop surface (conversationScope / onScopeChange / activeDocumentPath)
 * and delegates all rendering to the canonical selector component.
 */

import { WorkspaceScopeSelector } from './workspace-scope-selector'

export interface ChatScopeBadgeProps {
  conversationScope: string[] | null
  onScopeChange: (scope: string[] | null) => void
  activeDocumentPath?: string | null
  /** Compact trigger for composer column (pips only, minimal padding). */
  triggerClassName?: string
  /** Extra class names on the selected-workspace name. */
  nameClassName?: string
}

export function ChatScopeBadge({
  conversationScope,
  onScopeChange,
  activeDocumentPath,
  triggerClassName,
  nameClassName,
}: ChatScopeBadgeProps) {
  return (
    <WorkspaceScopeSelector
      scope={conversationScope}
      onScopeChange={onScopeChange}
      activeDocumentPath={activeDocumentPath}
      label="Chat scope"
      triggerClassName={triggerClassName}
      nameClassName={nameClassName}
      tooltip="Workspaces tagged on this chat. Saved when you send."
    />
  )
}
